// Strings shown by AppBootstrap while the app config loads (before the authenticated tree mounts).
const app = {
  loading: "Anwendung wird geladen...",
  loadError: "Anwendung konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
};

export default app;
